import React, { useState,Suspense,lazy} from "react";
import { useLocation, useParams, useHistory } from "react-router";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Helmet } from "react-helmet";
import ErrorBoundary from "../Commons/errorBoundary";
import MySnackbar from "../Commons/mySnackbar";
import TripDetail from "../MyTripKart/TripDetail";
import TAWebLayout from "../AgentWebsite/Layout";
import { AppContext, devConsolelog, queryStringToObj,LoadingComponent } from "../../Utility";
import "./App.css";



const AgentWebsite = lazy(() => import("../AgentWebsite"));


export default ({ children = null }) => {
  const [openDailog, setOpenDailog] = useState(false);
  const [viewSnackbar, setViewSnackbar] = useState({
    message: null,
    type: null,
  });
  const deskTopView = useMediaQuery((theme) => theme.breakpoints.up("md"));
  let history = useHistory(),
    match = useParams(),
    location = useLocation();

  let searchParams = queryStringToObj(location.search);

  const contextValue = {
    deskTopView,
    setViewSnackbar,
    devConsolelog,
    appLayoutContext: AppContext,
    setOpenDailog,
    originalQuery: location.search,
    searchParams,
  };
  devConsolelog("router match: ", location, match, viewSnackbar);
  if (
    children ||
    "package" in searchParams ||
    "customerQuoteId" in match ||
    "customer_quote" in searchParams ||
    "resellerListingId" in match
  ) {
    return (
      <AppContext.Provider value={contextValue}>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        <Helmet>
          <link
            preload
            href="https://fonts.googleapis.com/css?family=Titillium+Web&display=swap"
            rel="stylesheet"
          />
        </Helmet>
        <ErrorBoundary>
          <div>{children || <TripDetail />}</div>
        </ErrorBoundary>
        <ErrorBoundary>
          {Boolean(viewSnackbar.message) && (
            <MySnackbar
              variant={viewSnackbar.type}
              message={viewSnackbar.message}
              setViewSnackbar={setViewSnackbar}
            />
          )}
        </ErrorBoundary>
      </AppContext.Provider>
    );
  } else {
    return (
      <TAWebLayout>
        <Suspense fallback={<LoadingComponent />}>
        <AgentWebsite />
        </Suspense>
      </TAWebLayout>
    );
  }
};
